import { Image, H4, H6, P } from '../../../../../../AbstractElements';
import { JohanDeo, JohanDeoMailId, ProjectDescription, ProjectDescriptionDetails } from '../../../../../../Constant';
import { Col, Media, Row } from 'reactstrap';
import React, { Fragment } from 'react';
import { useLocation } from 'react-router';


const InvoiceDescription = () => {

  const location = useLocation()
  const {rowData,data} = location.state || {}

  console.log(data)

    return (
    <Fragment>
      {/* <Row className='invo-profile'> */}
      {/* <div className='d-flex justify-content-between'></div> */}
        <div className='d-flex justify-content-between'>
        {/* <Col> */}
          <div className='invo-profile-left'>
            <Media>
              {/* <div className='media-left'>
                <Image attrImage={{ className: 'media-object rounded-circle img-60', src: `${user1}`, alt: '' }} />
              </div> */}
              <Media body className=''>
                <H4 attrH4={{ className: 'media-heading f-w-600' }}>{data.first_name}</H4>
                <P>
                  {data.email? data.email : null}
                  <br />
                  <span className='digits'>{data.phone}</span>
                </P>
              </Media>
            </Media>
          </div>
        {/* </Col> */}
        {/* <Col> */}
        {/* <Col> */}
          <div className='text-md-end'>
            <div id='project'>
              <H6>{"Patient ID"}</H6>
              <P>{data.patient_reg_no}</P>
            </div>
          </div>
        {/* </Col> */}
        </div>
      {/* </Row> */}
    </Fragment>
  );
};
export default InvoiceDescription;
